export default __webpack_public_path__ + "static/media/synapses.20d7bc07.svg";